// extracted by mini-css-extract-plugin
export default {"founders":"founders--pEaao","founders-item":"founders-item--s8E58","foundersItem":"founders-item--s8E58","blink":"blink--XMYFs"};